import {
	type AccessFlow,
	ComponentUnion,
	FlexibleActionCardModel,
	FlexibleButtonHyperlinkModel,
	FlexibleButtonIconModel,
	FlexibleButtonModel,
	FlexibleImageModel,
	FlexibleListDirectionalModel,
	FlexibleListedAtReceptionsModel,
	FlexibleListModel,
	FlexibleRecentVisitsModel,
	FlexibleSearchModel,
	FlexibleSpacerModel,
	FlexibleTextModel,
} from '@services/flexible_component/mod';
import { FlexibleActionCard } from './flexible_identifier_flexible_action_card.component';
import { FlexibleButton } from './flexible_identifier_flexible_button.component';
import { FlexibleButtonHyperlink } from './flexible_identifier_flexible_button_hyperlink.component';
import { FlexibleButtonIcon } from './flexible_identifier_flexible_button_icon.component';
import { FlexibleImage } from './flexible_identifier_flexible_image.component';
import { FlexibleList } from './flexible_identifier_flexible_list.component';
import { FlexibleListDirectional } from './flexible_identifier_flexible_list_directional.component';
import { FlexibleListedAtReceptions } from './flexible_identifier_flexible_listed_at_receptions.component';
import { FlexibleRecentVisits } from './flexible_identifier_flexible_recent_visits.component';
import { FlexibleRockBottom } from './flexible_identifier_flexible_rock_bottom.component';
import { FlexibleSearch } from './flexible_identifier_flexible_search.component';
import { FlexibleSpacer } from './flexible_identifier_flexible_spacer.component';
import { FlexibleText } from './flexible_identifier_flexible_text.component';

interface Props {
	component: ComponentUnion;
	__TEMP__on_OPW_WebContentButton_proxy_invoke?: (flexibleIdentifierData: {
		url: string;
		openUrlWith: string;
		requiresAuthentication: boolean;
	}) => void;
	accessFlow?: AccessFlow;
}

export function FlexibleIdentifier({ component, __TEMP__on_OPW_WebContentButton_proxy_invoke, accessFlow }: Props): JSX.Element {
	if (component instanceof FlexibleButtonIconModel) {
		return (
			<FlexibleButtonIcon
				component={component}
				__TEMP__on_OPW_WebContentButton_proxy_invoke={__TEMP__on_OPW_WebContentButton_proxy_invoke}
			/>
		);
	}

	if (component instanceof FlexibleButtonModel) {
		return (
			<FlexibleButton
				component={component}
				__TEMP__on_OPW_WebContentButton_proxy_invoke={__TEMP__on_OPW_WebContentButton_proxy_invoke}
			/>
		);
	}

	if (component instanceof FlexibleButtonHyperlinkModel) {
		return <FlexibleButtonHyperlink component={component} />;
	}

	if (component instanceof FlexibleImageModel) {
		return <FlexibleImage component={component} />;
	}

	if (component instanceof FlexibleListModel) {
		return <FlexibleList component={component} />;
	}
	if (component instanceof FlexibleListDirectionalModel) {
		return <FlexibleListDirectional component={component} />;
	}

	if (component instanceof FlexibleTextModel) {
		return <FlexibleText component={component} />;
	}
	if (component instanceof FlexibleSearchModel) {
		return <FlexibleSearch component={component} />;
	}

	if (component instanceof FlexibleSpacerModel) {
		return <FlexibleSpacer component={component} />;
	}

	if (component instanceof FlexibleRecentVisitsModel) {
		return <FlexibleRecentVisits component={component} />;
	}

	if (component instanceof FlexibleListedAtReceptionsModel) {
		return <FlexibleListedAtReceptions component={component} />;
	}

	if (component instanceof FlexibleActionCardModel) {
		return (
			<FlexibleActionCard
				component={component}
				__TEMP__on_OPW_WebContentButton_proxy_invoke={__TEMP__on_OPW_WebContentButton_proxy_invoke}
				accessFlow={accessFlow}
			/>
		);
	}

	return <FlexibleRockBottom component={component} />;
}
